/**
 * @file 常用util
 * @author mengchen <mengchen@babytree-inc.com>
 */
import { lazyWLA } from "utils/lazylib";
import dayjs from 'dayjs'
import bbtNative from '@bbtfe/native';
import bbtVersion from '@bbtfe/version';
import React from "react";

const isAndroid =
  navigator.userAgent.indexOf('Android') > -1 ||
  navigator.userAgent.indexOf('Adr') > -1;

// 万分格式化
export function getNumberToMyriad(str) {
  if (isNaN(str)) {
    return str;
  }
  const num = Number(str)
  if (num >= 10000 && num <= 9990000) {
    return `${Number((num / 10000).toFixed(1))}万`
  } else if (num > 9990000) {
    return '999万+'
  } else {
    return String(num)
  }
}

export function getUrlParam(name) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
  const r = window.location.search.substr(1).match(reg);
  if (r !== null) return unescape(r[2]);
  return null;
}

// 用于埋点字段的be包裹
export function getBE(be) {
  let unionid = getUrlParam('unionid');
  let store_id = getUrlParam('store_id');
  return `${be ? `${be}$` : ''}H5_way=${getH5Way()}${unionid ? `$unionid=${unionid}` : ''
    }${store_id ? `$store_id=${store_id}` : ''}`;
}

// 用于埋点的beH5_way字段
export const getH5Way = function () {
  let H5_way;
  const userAgent = UAParser();
  const { miniProgram } = userAgent;
  if (H5_way) return H5_way;
  if (bbtNative.isApp()) {
    H5_way = '1';
  } else if (miniProgram) {
    H5_way = '3';
  } else if (getUrlParam('share_uid')) {
    H5_way = '4';
  } else {
    H5_way = '2';
  }
  return H5_way;
};

/**
 * 
 * @param {HTMLElement} options.el dom元素
 * @param {Boolean} options.once 为true则只在初始时触发或改变方向时触发options.Function
 * @param {Function} options.moveLeft moveLeft
 * @param {Function} options.moveRight moveRight
 * @param {Function} options.moveTop moveTop
 * @param {Function} options.moveBottom moveBottom
 * @returns 
 */
export function mouseMoveObsever(options) {

  const { el, moveLeft, moveRight, moveTop, moveBottom, once } = {
    el: null,
    moveLeft: () => { },
    moveRight: () => { },
    moveTop: () => { },
    moveBottom: () => { },
    once: true,
    ...options,
  }
  if (!(el instanceof HTMLElement)) return console.error('el不是HTMLElement类型');
  let startX, startY, moveEndX, moveEndY, X, Y, flag, direction;
  function touchstartHandle(e) {
    once && (flag = true)
    // e.preventDefault();
    startX = e.changedTouches[0].pageX,
      startY = e.changedTouches[0].pageY;
  }
  function changeFlagWithDirection(newDirection) {
    if (direction !== newDirection) {
      once && (flag = true)
    }
  }
  function touchmoveHandle(e) {
    // e.preventDefault();

    moveEndX = e.changedTouches[0].pageX,
      moveEndY = e.changedTouches[0].pageY,
      X = moveEndX - startX,
      Y = moveEndY - startY;
    startX = moveEndX;
    startY = moveEndY;

    if (X > 0) {
      changeFlagWithDirection('right')
      direction = 'right'
      flag && moveRight instanceof Function && moveRight();
    }
    else if (X < 0) {
      changeFlagWithDirection('left')
      direction = 'left'
      flag && moveLeft instanceof Function && moveLeft();
    }
    else if (Y > 0) {
      changeFlagWithDirection('top')
      direction = 'top'
      moveTop instanceof Function && moveTop();
    }
    else if (Y < 0) {
      changeFlagWithDirection('bottom')
      direction = 'bottom'
      moveBottom instanceof Function && moveBottom();
    }
    else {
      console.log("anything else");
    }
    once && (flag = false);
  }
  return {
    register() {
      el.addEventListener("touchstart", touchstartHandle)
      el.addEventListener("touchmove", touchmoveHandle)
    },
    destroy() {
      el.removeEventListener("touchstart", touchstartHandle)
      el.removeEventListener("touchmove", touchmoveHandle)
    }
  }
}


export function openApp(config = {}) {
  if (window.__wla) {
    window.__wla.open(config);
  } else {
    lazyWLA()
      .then((WLA) => {
        let refcode = 'm_y_share_mkzjgj_20220629';
        window.__wla = new WLA({
          scheme: location.href,
          pkgs: {
            channel: {
              refcode,
              url: isAndroid
                ? "//r.babytree.com/7abjWMG"
                : "//r.babytree.com/5wHppNY",
            }
          },
          wta: {
            appid: '11',
            view: location.href,
            bid: 'W2A_DL_190726',
            param: {},
            tid: '',
            refcode
          }
        });
        window.__wla.open(config);
      })
      .catch((error) => {
        console.log('wla-error---', error)
      });
  }
}

/**
 * wla触发
 * @param {object|引用类型} wlaInstance 用来接收wla实例 
 * @param {Function} getWlaIns 用来接收wla实例的方法 ，入参为 wla实例 
 * @param {Function} onDownloadBtnClick 【打开应用】按钮的点击handle
 * @returns 
 */
export function executeWLA(params) {
  const defaultOp = {
    wlaInstance: {},
    getWlaIns: () => { },
    onDownloadBtnClick: () => { },
  }
  const options = {
    ...defaultOp,
    ...params,
  }
  const { getWlaIns, onDownloadBtnClick } = options;
  let { wlaInstance } = options;

  return lazyWLA().then((WLA) => {
    const wla = new WLA({
      scheme: window.location.href,
      pkgs: {
        channel: {
          refcode: "m_y_share_mkzjgj_20220629",
          url: isAndroid
            ? "//r.babytree.com/7abjWMG"
            : "//r.babytree.com/5wHppNY",
        },
      },
    });
    getWlaIns && getWlaIns(wla);
    if (wlaInstance) {
      wlaInstance = wla;
    }
    setTimeout(() => {
      wla.destroy();
    }, 2000);
    wla.render("DownloadBar", {
      btnText: "打开应用",
      onDownloadBtnClick: () => {
        onDownloadBtnClick && onDownloadBtnClick();
        wla.open();
      },
    });
  });
}

// 判断是否需要在app内打开
export function includeBBTProtocol(str) {
  return str.includes("bbtrp://")
}

const loadPromises = {};

export function loadScript(src, opts = {}) {
  if (loadPromises[src]) {
    return loadPromises[src];
  }
  const promise = (loadPromises[src] = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = opts.type || 'text/javascript';
    script.charset = opts.charset || 'utf8';
    script.async = 'async' in opts ? !!opts.async : true;
    script.src = src;
    if (opts.attrs) {
      for (var attr in opts.attrs) {
        script.setAttribute(attr, opts.attrs[attr]);
      }
    }
    let loaded = false;
    script.onload = script.onreadystatechange = function () {
      if (
        (script.readyState &&
          script.readyState !== 'complete' &&
          script.readyState !== 'loaded') ||
        loaded
      ) {
        return false;
      }
      script.onload = script.onreadystatechange = null;
      loaded = true;
      resolve();
    };
    script.onerror = function () {
      script.onload = script.onreadystatechange = null;
      reject();
    };
    const body = document.getElementsByTagName('body')[0];
    body.appendChild(script);
    // const head = document.getElementsByTagName('head')[0];
    // head.insertBefore(script, head.firstChild);
  }));
  return promise;
}

export function loadCSSCode(code) {
  const style = document.createElement('style');
  style.type = 'text/css';
  style.rel = 'stylesheet';
  //for Chrome Firefox Opera Safari
  style.appendChild(document.createTextNode(code));
  //for IE
  //style.styleSheet.cssText = code;
  const head = document.getElementsByTagName('head')[0];
  head.appendChild(style);
}

export function loadCSS(href) {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = href;
  const head = document.getElementsByTagName('head')[0];
  head.appendChild(link);
}

export function loadImage(src) {
  if (loadPromises[src]) {
    return loadPromises[src];
  }
  const promise = (loadPromises[src] = new Promise((resolve, reject) => {
    const img = document.createElement('img');
    img.src = src;
    img.onload = function () {
      resolve(img);
    };
    img.onerror = function (e) {
      img.onload = null;
      reject(e);
    };
  }));
  return promise;
}

export function getPromise(timeout = 0) {
  return new Promise(function (resolve) {
    const timerId = window.setTimeout(function () {
      window.clearTimeout(timerId);
      resolve();
    }, timeout);
  });
}

export function imageToBase64(url, outputFormat) {
  return new Promise((resolve) => {
    let canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new window.Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      canvas.height = img.height;
      canvas.width = img.width;
      ctx.drawImage(img, 0, 0);
      const dataURL = canvas.toDataURL(outputFormat || 'image/png');
      resolve(dataURL);
      canvas = null;
    };
    img.src = url;
  });
}

const RegExpMap = {
  Edge: /Edge/i,
  Wechat: /MicroMessenger/,
  Weibo: /Weibo/,
  QQ: /\sQQ\//,
  MQQBrowser: /MQQBrowser/i,
  Qzone: /\sQzone\//,
  Mobile: /Mobile/,
  Android: /Android/,
  iOS: /iPhone|iPad|iPod/,
  iPhone: /iPhone/,
  isAppleDevice: /iPad|iPhone|iPod|Mac OS X/,
  isBot: /Baiduspider|Sogou\s\w+\sspider|Yisouspider|Googlebot|Bingbot|360Spider/,
  Tablet: /(iPad|Tablet)|(Android.*Chrome(?!.*Mobile))/,
  UC: /UCBrowser/,
  Sogou: /Sogou/,
  Qihoo: /QHBrowser/,
  Baidu: /baidubrowser/,
  BaiduApp: /baidubox/,
  Safari: /^((?!chrome|android).)*safari/i,
  GoogleBot: /Googlebot/,
  DingTalk: /DingTalk/, // 钉钉
  AlipayClient: /AlipayClient/, // 支付宝
  NewsArticle: /NewsArticle/, // 今日头条
  pregnancy: /(pregnancy|AliUnionMall)/, // 宝宝树孕育
  miniProgram: /miniProgram/, // 小程序
  lama: /lama/ // 小时光独立app
};

export function UAParser(ua) {
  ua = ua || window.navigator.userAgent;
  const userAgent = Object.keys(RegExpMap).reduce((total, item) => {
    total[item] = RegExpMap[item].test(ua);
    return total;
  }, {});
  if (document.referrer.indexOf('nativeapp.babytree.com') > -1) {
    userAgent.pregnancy = true;
  }
  if (
    /MSIE\s(\d+)\.(\d+)/i.exec(ua) ||
    /Trident.*rv[.:\s](\d+)\.(\d+)/i.exec(ua)
  ) {
    userAgent.IE = true;
  }
  if (userAgent.pregnancy && !userAgent.iPhone && !userAgent.Android) {
    const query = queryStringToObject(window.location.search);
    const clientType = query['babytree-client-type'];
    userAgent.iPhone = clientType == 'ios' ? true : false;
    userAgent.Android = clientType == 'android' ? true : false;
  }
  if (userAgent.iPhone && window.screen.height >= 812) {
    userAgent.iPhoneX = true;
  }
  userAgent.origin = ua;
  return userAgent;
}

// https://github.com/lodash/lodash/blob/master/isObject.js
export function isObject(value) {
  const type = typeof value;
  return value != null && (type === 'object' || type === 'function');
}

// 函数防抖和节流 : https://www.jianshu.com/p/c8b86b09daf0
// https://github.com/lodash/lodash/blob/master/debounce.js
export function debounce(func, wait, options) {
  let lastArgs, lastThis, maxWait, result, timerId, lastCallTime;

  let lastInvokeTime = 0;
  let leading = false;
  let maxing = false;
  let trailing = true;

  // Bypass `requestAnimationFrame` by explicitly setting `wait=0`.
  const useRAF =
    !wait && wait !== 0 && typeof window.requestAnimationFrame === 'function';

  if (typeof func !== 'function') {
    throw new TypeError('Expected a function');
  }
  wait = +wait || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? Math.max(+options.maxWait || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    const args = lastArgs;
    const thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function startTimer(pendingFunc, wait) {
    if (useRAF) {
      window.cancelAnimationFrame(timerId);
      return window.requestAnimationFrame(pendingFunc);
    }
    return setTimeout(pendingFunc, wait);
  }

  function cancelTimer(id) {
    if (useRAF) {
      return window.cancelAnimationFrame(id);
    }
    clearTimeout(id);
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = startTimer(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    const timeSinceLastCall = time - lastCallTime;
    const timeSinceLastInvoke = time - lastInvokeTime;
    const timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? Math.min(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    const timeSinceLastCall = time - lastCallTime;
    const timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (
      lastCallTime === undefined ||
      timeSinceLastCall >= wait ||
      timeSinceLastCall < 0 ||
      (maxing && timeSinceLastInvoke >= maxWait)
    );
  }

  function timerExpired() {
    const time = Date.now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = startTimer(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      cancelTimer(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(Date.now());
  }

  function pending() {
    return timerId !== undefined;
  }

  function debounced(...args) {
    const time = Date.now();
    const isInvoking = shouldInvoke(time);

    lastArgs = args;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = startTimer(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = startTimer(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  debounced.pending = pending;
  return debounced;
}

// https://github.com/lodash/lodash/blob/master/throttle.js
export function throttle(func, wait, options) {
  let leading = true;
  let trailing = true;

  if (typeof func !== 'function') {
    throw new TypeError('Expected a function');
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    leading,
    trailing,
    maxWait: wait
  });
}

export const queryStringToObject = (query) => {
  let json = {};
  if (!query || typeof query !== 'string') {
    return json;
  }
  if (query.indexOf('?') == 0) {
    query = query.substr(1);
  }
  let qarr = query.split('&');
  for (let i of qarr) {
    let item = i.split('=');
    json[item[0]] = item[1];
  }
  return json;
};

export const objectToQueryString = (queryParameters) => {
  return queryParameters
    ? Object.entries(queryParameters).reduce(
      (queryString, [key, val], index) => {
        const symbol = queryString.length === 0 ? '?' : '&';
        queryString +=
          typeof val === 'string' ? `${symbol}${key}=${val}` : '';
        return queryString;
      },
      ''
    )
    : '';
};

export const isPassive = function () {
  var supportsPassiveOption = false;
  try {
    addEventListener(
      'test',
      null,
      Object.defineProperty({}, 'passive', {
        get: function () {
          supportsPassiveOption = true;
        }
      })
    );
  } catch (e) { }
  return supportsPassiveOption;
};

export const preventDefault = function (e) {
  e.preventDefault();
};

export const http2any = function (url) {
  return url ? url.replace(/^http[s]?[:]?/, '') : null;
};

//默认显示 MM:ss 格式 都保持两位数
export const formatTime = (timesecs) => {
  if (!(timesecs >= 0)) return '0';
  let m = Math.floor(Math.floor(timesecs) / 60);
  let s = Math.floor(Math.floor(timesecs) % 60);
  let h = Math.floor(Math.floor(m) / 60);
  m = Math.floor(Math.floor(m) % 60);
  let r = '';

  m = m < 10 ? '0' + m : m;
  s = s < 10 ? '0' + s : s;
  if (h > 0) {
    r = `${h}:${m}:${s}`;
  } else {
    r = `${m}:${s}`;
  }
  if (r.indexOf('-') > -1) {
    r = '00:00';
  }
  return r;
}

const prefetches = new Set();

export const preload = function (url) {
  if (prefetches.has(url)) {
    return;
  }

  const prefetcher = document.createElement('link');
  prefetcher.rel = 'prefetch';
  prefetcher.href = url;
  document.head.appendChild(prefetcher);

  prefetches.add(url);
};

export const formatDuration = function (duration) {
  let second = Math.ceil(duration / 1);
  if (!second) {
    return '00:00';
  }
  let time = '';
  if (second >= 24 * 3600) {
    time = `${time}${Math.floor((second / 24) * 3600, 10)}:`;
    second %= 24 * 3600;
  }
  if (second >= 3600) {
    time = `${time}${Math.floor(second / 3600, 10)}:`;
    second %= 3600;
    if (second < 60) {
      time = `${time}0:`;
    }
  }
  if (second >= 60) {
    time = `${time}${Math.floor(second / 60, 10)}:`;
    second %= 60;
  }
  if (second >= 0) {
    time += second;
  }
  const arr = time.split(':');
  // let day = "";
  let h = '';
  let min = '';
  let sec = '';
  let str = '';
  arr[arr.length - 1] = Math.ceil([arr[arr.length - 1]], 10);
  if (arr.length === 1) {
    sec = arr[0] < 10 ? `0${arr[0]}` : arr[0];
    str = `00:${sec}`;
  }
  if (arr.length === 2) {
    min = arr[0] < 10 ? `0${arr[0]}` : arr[0];
    sec = arr[1] < 10 ? `0${arr[1]}` : arr[1];
    str = `${min}:${sec}`;
  }
  if (arr.length === 3) {
    h = arr[0] < 10 ? `0${arr[0]}` : arr[0];
    min = arr[1] < 10 ? `0${arr[1]}` : arr[1];
    sec = arr[2] < 10 ? `0${arr[2]}` : arr[2];
    str = `${h}:${min}:${sec}`;
  }
  if (arr.length === 4) {
    // day=arr[0]<10?'0'+arr[0]:arr[0];
    h = arr[1] < 10 ? `0${arr[1]}` : arr[1];
    min = arr[2] < 10 ? `0${arr[2]}` : arr[2];
    sec = arr[3] < 10 ? `0${arr[3]}` : arr[3];
    str = `${h}:${min}:${sec}`;
  }
  return str;
};

// 处理价钱
export function transformPrice(price) {
  const priceArr = String(Number(price)).split('.');
  return {
    getInt: () => priceArr[0],
    getIntWithDot: () => `${priceArr[1] ? `${priceArr[0]}.` : (priceArr[0] || 0)}`,
    getFloat: () => `${priceArr[1] || ''}`,
    getFloatWithDot: () => `${priceArr[1] ? `.${priceArr[1]}` : ''}`,
  };
}

//获取时间戳的格式化字符串显示
export function getFormatedTsStr(timestamp) {
  // let timestamp = dayjs('2022-08-15 00:05').unix()
  if (!timestamp) return ''
  let newDateTimeSeconds = new Date().getTime() / 1000;

  let result = '';
  if (dayjs(timestamp * 1000).year() === dayjs().year()) {
    result = dayjs(timestamp * 1000).format('MM-DD')
  } else {
    result = dayjs(timestamp * 1000).format('YYYY-MM-DD')
  }


  let secondsDiff = newDateTimeSeconds - timestamp;

  if (secondsDiff < 0) {
    return result;
  }

  if (secondsDiff <= 60) {
    result = '刚刚';

  } else if (secondsDiff <= 3600) {
    result = `${parseInt(secondsDiff / 60)}分钟前`;

  } else if (secondsDiff <= 86400) {
    result = `${parseInt(secondsDiff / 3600)}小时前`;

  } else if (secondsDiff <= 86400 * 3) {
    result = `${parseInt(secondsDiff / 86400)}天前`;
  }

  return result;
}

/**
 * 
 * @param {number} position 预览图片的起始位置
 * @param {string} jsonArray 图片地址的数组 如：['https://www.baidu.com/img1','https://www.baidu.com/img2']
 * @returns null
 */
export const setNativePhotoListBrowse = (position, jsonArray) => {
  if (bbtVersion.less('9.18.0')) {
    return bbtNative.previewImage(jsonArray[position]);
  }
  const jsonArrayStr = JSON.stringify(jsonArray)
  if (window.Bridge && window.Bridge.postMessage) {
    window.Bridge.postMessage({
      method: 'nativePhotoListBrowse',
      params: [position, jsonArrayStr]
    });
    return;
  }
  if (
    window.nativePhotoListBrowse &&
    typeof window.nativePhotoListBrowse == 'function'
  ) {
    window.nativePhotoListBrowse(position, jsonArrayStr);
    return;
  }
  if (window.android && window.android.nativePhotoListBrowse) {
    window.android.nativePhotoListBrowse(position, jsonArrayStr);
    return;
  }
}



/**
 * h5辅助客户端刷新首页feeds相关推荐数据
 * @param {string} dataSourceId 区分内容类型  164文章  165新知识
 * @param {string} contentId 内容id
 * @param {string} traceId url上带过去的trace_id
 * @returns 
 */
export const setNativeGetFeedRecommend = (dataSourceId, contentId, traceId) => {
  if (bbtVersion.less('9.18.0')) return;
  if (window.Bridge && window.Bridge.postMessage) {
    window.Bridge.postMessage({
      method: 'nativeGetFeedRecommend',
      params: [dataSourceId, contentId, traceId]
    });
    return;
  }
  if (
    window.nativeGetFeedRecommend &&
    typeof window.nativeGetFeedRecommend == 'function'
  ) {
    window.nativeGetFeedRecommend(dataSourceId, contentId, traceId);
    return;
  }
  if (window.android && window.android.nativeGetFeedRecommend) {
    window.android.nativeGetFeedRecommend(dataSourceId, contentId, traceId);
    return;
  }
}

/**
 * 
 * @param {object} lopts 
 * container 挂在的容器，用于注册scroll事件
 * componentType 默认为'CC',默认是类组件，如果是函数组件，则应传入conponentType:'FC'
 * emitDistance 下滑或上划到emitDistance距离之后懒加载通过LazyModule包裹的模块
 * @returns 
 * {
 *  register: 注册scroll事件
 *  destroy: 移除scroll事件，清楚不再使用变量
 *  LazyModule: 通过该方法包裹需要懒加载的模块
 *      入参：
 *          id: 需要是唯一的，目前方法内没有校验唯一值，使用时需要注意
 *          lazyRender: 需要懒加载的模块，应当符合 () => <div/> 或 () => <ReactDemo test={this.state.test} test2={this.props} /> 的语法
 *              📢注意：如果需要给 <ReactDemo/> 组件需要传入参数，应当基于this传入值，也就是应当传入引用类型，否则react组件刷新之后没办法在lazyRender的react组件中跟踪到父组件最新的状态
 *  refreshModule: 针对首屏数据较少无法触发滚动事件监听是否应该加载【懒加载模块】的情况
 *      为了兼容首屏就加载【懒加载模块】的情况
 *      请在必要的时机中调用refreshModule事件，比如componentDidMount的detail请求回调里
 *      由于本事件已经做了过滤，所以不用担心因此会造成性能问题
 *  getIsAllModulesRendered 返回boolean值，表示是否已经加载完成所有懒加载模块
 *  manualRenderLazyModule 
 *      入参
 *        id 可以是字符串或字符串数组
 *      返回Promise
 *        then触发表示已经将懒加载模块渲染到了页面上，这时可以操作懒加载模块的页面元素。
 *        catch表示渲染失败
 * 
 * }
 */
export const LazyLoadModule = function (lopts) {
  lopts = {
    container: document.querySelector('.lazyloadcontainer') || window,
    emitDistance: 300,
    componentType: 'CC',
    ...lopts,
  };
  const lazyloadModulePrefix = '__lazyload-module-';
  const lazyloadModuleMap = {};
  const thisMap = new Map();
  // CC 为类组件； FC是函数组件
  const reRender = ({ module: renderModule, id: renderId }) => {
    if (!renderModule) return;
    renderModule.returnElement = renderModule.lazyRender
    renderModule.firstRendered = true;

    return new Promise((resolve, reject) => {
      try {
        setTimeout(() => {
          if (lopts.componentType === 'CC') {
            thisMap.get(renderId).forceUpdate(() => {
              resolve({ id: renderId, status: 'ok' })
            });
          } else {
            renderModule.renderFn && renderModule.renderFn();
          }
        }, 0);
      } catch (err) {
        reject({ err, id: renderId, status: 'error' })
      }
    })
  }
  const scrollHandle = () => {
    if (getIsAllModulesRendered()) return;
    let screenHeight = window.innerHeight || window.outerHeight || document.documentElement.clientHeight;
    Object.entries(lazyloadModuleMap).map(_module => {
      const [id, module] = _module
      if (module.firstRendered) return;
      const { top, bottom } = document.querySelector(`.${lazyloadModulePrefix}${id}`).getBoundingClientRect()
      if (top - screenHeight > 0 && top - screenHeight < lopts.emitDistance) {
        // console.log('触发200--顶部', module, id);
        reRender({ module, id });
      }
      if (top >= 0 && top <= screenHeight) {
        // console.log('触发200--中间', document.querySelector(`.${lazyloadModulePrefix}${id}`));
        reRender({ module, id });
      }
      if (bottom < 0 && Math.abs(bottom) < lopts.emitDistance) {
        // console.log('触发200--底部', document.querySelector(`.${lazyloadModulePrefix}${id}`));
        reRender({ module, id });
      }
    })
  }

  const getIsAllModulesRendered = () => {
    const modulesList = Object.values(lazyloadModuleMap)
    return modulesList.every(module => module.firstRendered)
  }


  return {
    // 获取是否已经将模块加载完毕
    getIsAllModulesRendered,
    // 注册监听事件
    register: () => {
      lopts.container.addEventListener('scroll', scrollHandle)
    },
    // 销毁监听事件
    destroy: () => {
      lopts.container.removeEventListener('scroll', scrollHandle)
    },
    // 将普通元素包装成懒加载模块
    LazyModule: (moduleOpts) => {
      if (!lazyloadModuleMap[moduleOpts.id]?.firstRendered) {
        thisMap.set(moduleOpts.id, this);
        lazyloadModuleMap[moduleOpts.id] = {
          lazyProps: {},
          ...moduleOpts,
          returnElement: null
        }
      } else {
        lazyloadModuleMap[moduleOpts.id] = {
          lazyProps: {},
          ...lazyloadModuleMap[moduleOpts.id],
          ...moduleOpts,
        }
      }
      const lazyloadModule = lazyloadModuleMap[moduleOpts.id];
      const { returnElement: TempDom, lazyProps } = lazyloadModule;
      // console.log('TempDom', lazyloadModuleMap, thisMap, lazyProps, TempDom);
      return (
        <div className={`${lazyloadModulePrefix}${moduleOpts.id}`}>
          {TempDom && <TempDom {...lazyProps} />}
        </div>
      )
    },
    // 刷新是否需要加载模块，如果需要则加载，如果不需要则不作操作
    refreshModule: () => {
      getIsAllModulesRendered() || scrollHandle();
    },
    // 手动渲染懒加载模块
    manualRenderLazyModule: (ids) => {
      if (typeof ids === 'string') {
        return reRender({ module: lazyloadModuleMap[ids], id: ids })
      }
      if (ids instanceof Array) {
        return Promise.all(ids.map(id => {
          return reRender({ module: lazyloadModuleMap[id], id })
        }))
      }
      console.error('输入的ids样式不对，仅支持字符串与数组字符串')
      return new Promise()
    }
  }
}